import { Col, Row as AntRow } from 'antd';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Drawer as DrawerAtom } from 'components/atoms/drawer';
import { TASK_DRAWER_WIDTH } from '../tasks/constants';

export const Drawer = styled(DrawerAtom).attrs({
  width: TASK_DRAWER_WIDTH,
  closable: true,
  placement: 'right',
  destroyOnClose: true,
})`
  .ant-drawer-body {
    padding: 0;
    overflow: hidden;
  }
`;

export const LoadingContainer = styled.div`
  width: 768px;
`;

export const Row = styled(AntRow).attrs({ wrap: false })<{ $private: boolean }>`
  border-top: solid 4px;
  border-top-color: var(--task-pane-header-bg);

  ${ifProp(
    '$private',
    css`
      border-top-color: var(--yellow-40);
    `,
  )};
  height: 100vh;
`;

export const TaskCol = styled(Col)`
  width: 595px;
  overflow: auto;
`;

export const ConversationsCol = styled(Col)`
  border-left: solid 1px var(--gray-20);
  overflow: hidden;
`;
